import React from 'react';
import styled, { keyframes } from 'styled-components';
const spinnerAnim = keyframes`
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
`;
const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 10px solid #383636; /* Blue */
  border-radius: 50%;
  animation: ${spinnerAnim} 1.5s linear infinite;
`;

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
`;
export default function LoadingSpinner() {
  return (
    <Container>
      <Spinner></Spinner>
    </Container>
  );
}
